import styled from 'styled-components';

export const FloatingPanelButton = styled.button`
  position: relative;
  min-width: 88px;
  width: 20vw;
  height: 56px;
  border: none;
  background-color: #fff;

  &:active {
    background-color: #f1f1f1;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const BottomButtonText = styled.span`
  font-size: 14px;
`;
